(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["react-keyed-file-browser"] = factory();
	else
		root["react-keyed-file-browser"] = factory();
})(window, function() {
return 